// Recursos inicial
export const initResources = {
  financial: [],
  human: [],
  material: [],
  access: [],
}
export const initAccessResource = {
  resource: "",
  details: "",
}
export const initFinancialResource = {
  resource: "",
  amount: "",
  details: "",
}
export const initHumanResource = {
  name: "",
  email: "",
  collaborator: "",
  expertise: "",
  area: "",
  position: "",
  phone: "",
  roles: [],
  other_activities: "",
  details: ""
}
export const initMaterialResource = {
  resource: "",
  details: "",
}